import React from 'react'

const Title = ({title=""}) => {
  return (
    <h2 className='header-title'>
        <svg xmlns="http://www.w3.org/2000/svg" width="46" height="4" viewBox="0 0 46 4" fill="none">
        <path d="M0 2H45.6567" stroke="url(#paint0_linear_1_512)" stroke-width="4"/>
        <defs>
            <linearGradient id="paint0_linear_1_512" x1="0" y1="2" x2="3.76525" y2="15.0691" gradientUnits="userSpaceOnUse">
            <stop stop-color="#96F38A"/>
            <stop offset="1" stop-color="#02D2C5"/>
            </linearGradient>
        </defs>
        </svg>
        {title}
    </h2>
  )
}

export default Title